import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { filter, includes, isEmpty, last, map, reverse, uniqBy } from 'lodash';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CardContent,
  Card,
  Grid,
  useMediaQuery,
  TableContainer,
  IconButton,
  Modal,
  Container,
  Switch,
  FormControlLabel,
  Paper,
  CircularProgress,
  useTheme,
} from '@mui/material';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { AiOutlineLogout } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { IoClose, IoImage } from 'react-icons/io5';
import { GiCheckMark } from 'react-icons/gi';
import { RxCross2, RxCrossCircled } from 'react-icons/rx';
import {
  MdAddAPhoto,
  MdDelete,
  MdFlipCameraIos,
  MdImageNotSupported,
  MdOutlineDelete,
  MdOutlineFileUpload,
} from 'react-icons/md';
import Webcam from 'react-webcam';
import { toast } from 'react-toastify';
import moment from 'moment';
import { IoMdCheckboxOutline } from 'react-icons/io';
import stationupdateService from '../../services/stationupdateService';
import itemDeliveryService from '../../services/itemDeliveryService';
import fileUploadService from '../../services/fileUploadService';
import { UserHeader } from '../../components/AdminHeader';
import Footer from '../../components/Footer';
import {
  base64ToFile,
  dataURLtoFile,
  getAddressFromCoords,
  isBase64Image,
  resizeImage,
} from '../../common';
import CloseIcon from '@mui/icons-material/Close';

const SupervisorForm = () => {
  // const navigate = useNavigate();
  const department = localStorage?.getItem('stations')
    ? JSON.parse(localStorage?.getItem('stations'))[0]
    : '';

  const roles = ['SUPERVISOR'];
  // const roles =
  //   localStorage?.getItem('roles') &&
  //   filter(
  //     JSON?.parse(localStorage?.getItem('roles')),
  //     (data) => data === 'SUPERVISOR' || data === 'MANAGER'
  //   );

  const webcamRef = useRef();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [id, setId] = useState('');
  const [capturePhoto, setCapturePhoto] = useState(false);
  const stationList = localStorage?.getItem('stations')
    ? JSON.parse(localStorage?.getItem('stations'))
    : '';
  const [stations, setStations] = useState([]);
  const [imageUploading, setImageLoading] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(
    localStorage?.getItem('stations')
      ? JSON.parse(localStorage?.getItem('stations'))[0]
      : ''
  );

  // const [departments, setDepartments] = useState([]);
  const [stationUpdateList, setStationUpdateList] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  // const [selectedDepartment, setSelectedDepartment] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [facingMode, setFacingMode] = useState('environment'); // Default to front camera
  const [photos, setPhotos] = useState([]); // Default to front camera
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleSuccess = (position) => {
      const { latitude, longitude } = position.coords;
      setLocation({ latitude, longitude });
    };

    const handleError = (error) => {
      setError(error.message);
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(handleSuccess, handleError);
    } else {
      setError('Geolocation is not supported by this browser.');
    }
  }, []);

  const toggleCamera = () => {
    setFacingMode((prevMode) => (prevMode === 'user' ? 'environment' : 'user'));
  };

  // const fetchStations = async () => {
  //   const response = await itemDeliveryService.getItemDeliveriesDetails();
  //   setStations({
  //     resources: map(
  //       filter(
  //         response.data,
  //         (data) =>
  //           data?.department_id === selectedDepartment &&
  //           data?.event_id === parseInt(localStorage?.getItem('event_id')) &&
  //           data?.allocated_qty !== 0
  //       ),
  //       (data) => {
  //         return {
  //           resource_name: data?.item_name,
  //           stock_available: false,
  //           stock_required: false,
  //           photo_url: '',
  //           station_name: department,
  //         };
  //       }
  //     ),
  //   });
  // };

  const fetchStationUpdate = () => {
    stationupdateService?.getStationUpdate()?.then((res) => {
      if (res?.status === 200) {
        setStationUpdateList(reverse(res?.data));
      }
    });
  };

  const handleDelete = async (id) => {
    try {
      await stationupdateService?.deleteStationUpdate(id);
      fetchStationUpdate();
    } catch (error) {
      console.error('Error deleting station', error);
    }
  };

  const fetchStations = async () => {
    const response = await itemDeliveryService.getItemDeliveriesDetails();
    const array = filter(
      response?.data,
      (data) =>
        includes(stationList, data?.station) &&
        data?.event_id === parseInt(localStorage?.getItem('event_id'))
    );
    setStations(uniqBy(array, 'station'));
  };

  useEffect(() => {
    fetchStations();
    fetchStationUpdate();
  }, []);

  // useEffect(() => {
  //   if (selectedDepartment) {
  //     fetchStations();
  //   }
  // }, []);

  const handleCapturePhoto = async (setFieldValue, fieldName) => {
    try {
      setImageLoading(true);
      const imageSrc = webcamRef.current.getScreenshot();
      if (!imageSrc) throw new Error('Failed to capture image from webcam.');

      // 🧭 Get current coordinates
      const coords = await new Promise((resolve, reject) =>
        navigator.geolocation.getCurrentPosition(
          (pos) => resolve(pos.coords),
          (err) => reject(new Error('Unable to get location: ' + err.message))
        )
      );

      // 📍 Get readable address
      const address = await getAddressFromCoords(
        coords.latitude,
        coords.longitude
      );

      const img = new Image();
      img.src = imageSrc;

      img.onload = async () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');

          // Draw the captured image
          ctx.drawImage(img, 0, 0);

          // 📝 Text lines to overlay
          const lines = [
            address,
            `Lat: ${coords.latitude.toFixed(
              5
            )} | Lng: ${coords.longitude.toFixed(5)}`,
            new Date().toLocaleString(),
          ];

          const padding = 10;
          const lineHeight = 18;
          const mapWidth = isMobile ? 140 : 200;
          const textWidth = canvas.width - mapWidth - padding * 3;
          const boxHeight = Math.max(
            lineHeight * lines.length + padding * 2,
            100
          );
          const y = canvas.height - boxHeight;

          // Draw dark overlay
          ctx.fillStyle = 'rgba(0,0,0,0.7)';
          ctx.fillRect(0, y, canvas.width, boxHeight);

          // 🌍 Static Google Map
          const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${coords.latitude},${coords.longitude}&zoom=14&size=${mapWidth}x${boxHeight}&markers=color:red%7C${coords.latitude},${coords.longitude}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;

          const mapImg = new Image();
          mapImg.crossOrigin = 'Anonymous';
          mapImg.src = staticMapUrl;

          let hasProcessed = false; // Prevent double calls

          const finalize = () => {
            if (hasProcessed) return;
            hasProcessed = true;

            // Export final image as file
            const stampedDataURL = canvas.toDataURL('image/jpeg');
            const stampedFile = dataURLtoFile(
              stampedDataURL,
              `photo_${Date.now()}.jpg`
            );

            // Update Formik field and trigger file handler
            setFieldValue(fieldName, stampedFile);
            handleFileChange(stampedFile);
          };

          // ✅ Map loaded successfully
          mapImg.onload = () => {
            try {
              const mapBottomPadding = 10;
              ctx.drawImage(
                mapImg,
                padding,
                y,
                mapWidth,
                boxHeight - mapBottomPadding
              );

              // Draw text on right side
              ctx.fillStyle = 'white';
              ctx.font = isMobile ? '10px Arial' : '16px Arial';
              ctx.textAlign = 'left';
              const textX = mapWidth + padding * 2;
              let textY = y + padding;

              lines.forEach((line) => {
                const words = line.split(' ');
                let lineText = '';
                words.forEach((word) => {
                  const testLine = lineText + word + ' ';
                  const metrics = ctx.measureText(testLine);
                  if (metrics.width > textWidth) {
                    ctx.fillText(lineText, textX, textY);
                    lineText = word + ' ';
                    textY += lineHeight;
                  } else {
                    lineText = testLine;
                  }
                });
                ctx.fillText(lineText, textX, textY);
                textY += lineHeight;
              });

              finalize();
            } catch (innerErr) {
              console.error('❌ Error drawing map/text:', innerErr);
              finalize(); // fallback to text-only
            }
          };

          // ❌ Map failed to load fallback
          mapImg.onerror = (err) => {
            console.warn('⚠️ Static map failed to load:', err);

            ctx.fillStyle = 'white';
            ctx.font = isMobile ? '10px Arial' : '16px Arial';
            ctx.textAlign = 'left';
            let textY = y + padding;

            lines.forEach((line) => {
              ctx.fillText(line, padding * 2, textY);
              textY += lineHeight;
            });

            finalize();
          };

          // Safety timeout if map never finishes loading
          setTimeout(finalize, 5000);
        } catch (canvasErr) {
          console.error('❌ Canvas processing error:', canvasErr);
          alert('Something went wrong while processing the photo.');
        }
      };

      img.onerror = () => {
        throw new Error('Failed to load captured image.');
      };
    } catch (err) {
      console.error('❌ handleCapturePhoto Error:', err);
      alert(
        err.message ||
          'Unable to capture photo. Please check camera or location permissions.'
      );
      setImageLoading(false);
    }
  };

  const updateStationData = async (photos, id) => {
    const res = stationupdateService
      ?.updateStationUpdate(id, {
        photo_url: JSON.stringify(photos),
      })
      ?.then((res) => {
        if (res?.status === 200) {
          toast?.success('Photo uploaded successfully');
          setPhotos([]);
          fetchStationUpdate();
        }
      });
  };

  const handleFileChange = async (input, id, images) => {
    let file = input;

    if (isBase64Image(input)) {
      file = base64ToFile(input);
    }

    if (file.size > 2 * 1024 * 1024) {
      file = await resizeImage(file);
    }

    try {
      setImageLoading(true);
      const res = await fileUploadService?.handleFileUpload(file);
      if (res?.status === 200) {
        const uploadedPhotos = !isEmpty(photos)
          ? [...photos, res?.data?.filename]
          : [res?.data?.filename];
        if (id) {
          updateStationData(
            !isEmpty(images) ? [...images, ...uploadedPhotos] : uploadedPhotos,
            id
          );
        } else {
          setPhotos(uploadedPhotos);
          toast?.success('Photo captured successfully');
          setCapturePhoto(false);
          setId(null);
        }
        // setFieldValue(
        //   fieldName,
        //   `https://verify360procam.pythonanywhere.com/static/images/${res?.data?.filename}`
        // );
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      if (!error?.response && isMobile) {
        toast.error(
          'Please Use the upload option only for file uploads, and use a separate capture button to capture photos.'
        );
      } else if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error('Something went wrong while uploading');
      }
    } finally {
      setImageLoading(false); // stop loading in all cases
    }
  };

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <UserHeader />
      <div style={{ flex: 1, overflowY: 'auto', paddingBottom: '64px' }}>
        <Container
          maxWidth='sm'
          sx={{
            pt: 2,
            bgcolor: '#f9f9f9',
            p: '0 !important',
            borderRadius: 2,
            p: 2,
            minHeight: '100vh',
            maxHeight: 'fit-content',
          }}
        >
          <Paper
            elevation={3}
            sx={{
              padding: '16px',
              maxHeight: 'fit-content',
              minHeight: '100vh',
            }}
          >
            <Typography
              sx={{
                display: 'flex',
                alignItems: 'center',
                fontSize: { xs: '1.5rem', sm: '1.2rem' },
                color: '#333',
                fontWeight: 600,
                mb: 2,
              }}
            >
              {includes(roles, 'SUPERVISOR') ? (
                <div style={{ fontSize: '0.9rem', fontWeight: 600 }}>
                  STATION UPDATES
                  {!isEmpty(stations) && `(${selectedDepartment})`}
                </div>
              ) : (
                <div
                  style={{
                    fontSize: '1rem',
                    fontWeight: 600,
                    display: 'flex',
                    justifyContent: 'center',
                    textDecoration: 'underline',
                    width: '100%',
                  }}
                >
                  STATION UPDATES
                </div>
              )}
            </Typography>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end', // This will place the label and select on opposite sides of the container
                // alignItems: 'center', // Vertically align them
                flexDirection: 'column',
                width: '100%', // Ensure it takes up the full width of the parent
              }}
            >
              {/* Label for Select Station */}
              {/* <div style={{width:'50%'}}> */}
              <div>
                <Typography
                  variant='body2'
                  sx={{ fontWeight: 520, fontSize: '0.675rem' }}
                >
                  SELECT STATION
                </Typography>
              </div>

              {/* Select component for Station */}
              <Select
                name='department_id'
                value={selectedDepartment}
                sx={{ width: '50%' }}
                onChange={(e) => {
                  setSelectedDepartment(e?.target?.value);
                  setPhotos(null);
                }}
                variant='outlined'
              >
                {!isEmpty(stations) ? (
                  map(stations, (option) => (
                    <MenuItem
                      key={option?.id}
                      value={option?.station}
                      sx={{ fontSize: '0.675rem' }}
                    >
                      {option?.station}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem sx={{ fontSize: '0.675rem' }}>
                    No data found
                  </MenuItem>
                )}
              </Select>
              {/* </div> */}
            </Box>

            {includes(roles, 'SUPERVISOR') && (
              <Formik
                initialValues={{
                  station_name: selectedDepartment,
                  stock_available: false,
                  stock_required: false,
                  photo_url: '',
                  event_id: localStorage?.getItem('event_id'),
                }}
                enableReinitialize
                validationSchema={Yup.object({
                  resources: Yup.array().of(
                    Yup.object({
                      photo_url: Yup.string().url('Invalid URL format'),
                    })
                  ),
                })}
                onSubmit={async (values, { resetForm }) => {
                  try {
                    const res = await stationupdateService?.createStationUpdate(
                      {
                        ...values,
                        photo_url: JSON.stringify(photos),
                        latitude: location?.latitude,
                        longitude: location?.longitude,
                      }
                    );
                    if (res?.status === 201) {
                      toast?.success('Data added successfully');
                      setPhotos(null);
                      fetchStationUpdate();
                      resetForm();
                    }
                  } catch (error) {
                    console.error('Error saving station data', error);
                  }
                }}
              >
                {({ values, setFieldValue, handleSubmit }) => (
                  <form onSubmit={handleSubmit}>
                    <Box sx={{ overflowX: 'auto' }}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ padding: '8px' }}>
                              {/* <strong>Stock Available</strong> */}
                            </TableCell>
                            <TableCell sx={{ padding: '8px' }}>
                              {/* <strong>Stock Required</strong> */}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell sx={{ padding: '8px' }}>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={values?.stock_available}
                                    onChange={() =>
                                      setFieldValue(
                                        'stock_available',
                                        !values?.stock_available
                                      )
                                    }
                                    name='stock_available'
                                  />
                                }
                                sx={{
                                  '& .MuiTypography-root': {
                                    fontSize: '0.675rem !important',
                                    fontWeight: 510,
                                  },
                                }}
                                label='STOCK AVAILABLE'
                              />
                            </TableCell>
                            <TableCell sx={{ padding: '8px' }}>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={values?.stock_required}
                                    onChange={() =>
                                      setFieldValue(
                                        'stock_required',
                                        !values?.stock_required
                                      )
                                    }
                                    name='stock_required'
                                  />
                                }
                                sx={{
                                  '& .MuiTypography-root': {
                                    fontSize: '0.675rem !important',
                                    fontWeight: 510,
                                  },
                                }}
                                label='STOCK REQUIRED'
                              />
                              {/* <input
                          type='checkbox'
                          name='stock_required'
                          checked={values?.stock_required}
                          onChange={() =>
                            setFieldValue(
                              'stock_required',
                              !values?.stock_required
                            )
                          }
                        /> */}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </Box>

                    {/* Display Photos */}
                    {!isEmpty(photos) && (
                      <Box sx={{ mt: 2 }}>
                        <Grid container spacing={2}>
                          {photos.map((data, index) => (
                            <Grid item xs={3} key={data}>
                              {' '}
                              {/* xs={3} will make 4 items per row */}
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  fontSize: '0.9rem',
                                }}
                              >
                                <img
                                  src={`${process.env.REACT_APP_IMAGE_URL}/images/${data}`}
                                  alt='image'
                                  style={{
                                    height: '50px',
                                    width: '50px',
                                    borderRadius: '6px',
                                    marginRight: '8px', // Optional: to add spacing between image and delete icon
                                  }}
                                />
                                <MdOutlineDelete
                                  fill='red'
                                  size={22}
                                  cursor='pointer'
                                  onClick={() =>
                                    setPhotos(
                                      filter(photos, (data, i) => i !== index)
                                    )
                                  }
                                />
                              </Box>
                            </Grid>
                          ))}
                        </Grid>
                      </Box>
                    )}

                    {/* Webcam for photo capture */}
                    {capturePhoto &&
                      (imageUploading ? (
                        <CircularProgress size={22} />
                      ) : (
                        <>
                          <Webcam
                            audio={false}
                            ref={webcamRef}
                            screenshotFormat='image/jpeg'
                            videoConstraints={{ facingMode }}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                            // screenshotFormat='image/jpeg'
                            // videoConstraints={{
                            //   width: { ideal: 1920 }, // Reduce resolution to Full HD
                            //   height: { ideal: 1080 },
                            //   facingMode: facingMode,
                            // }}
                            // className='responsive-webcam'
                          />

                          <Box
                            sx={{
                              display: 'flex',
                              gap: 1,
                              mt: 2,
                            }}
                          >
                            <Button
                              variant='contained'
                              sx={{
                                textTransform: 'none',
                                p: '0 10px',
                                fontSize: '0.675rem',
                              }}
                              onClick={() =>
                                handleCapturePhoto(setFieldValue, 'photo_url')
                              }
                            >
                              CAPTURE
                            </Button>
                            <Button
                              variant='contained'
                              sx={{
                                textTransform: 'none',
                                p: '0 10px',
                                fontSize: '0.675rem',
                              }}
                              onClick={() => {
                                setId(null);
                                setCapturePhoto(false);
                              }}
                            >
                              CANCEL
                            </Button>
                            <MdFlipCameraIos
                              style={{ marginRight: '5px', cursor: 'pointer' }}
                              fill='#1876D1'
                              onClick={toggleCamera}
                              size={25}
                            />
                          </Box>
                        </>
                      ))}

                    <Box sx={{ mt: 2 }}>
                      <Box
                        sx={{ display: 'flex', gap: 2, alignItems: 'center' }}
                      >
                        {/* <MdAddAPhoto
                    onClick={() => setCapturePhoto(true)}
                    size={25}
                    fill='#1876D1'
                    cursor='pointer'
                  /> */}
                        {!capturePhoto && (
                          <Button
                            variant='contained'
                            color='error'
                            sx={{
                              textTransform: 'none',
                              p: '6px 10px',
                              fontSize: '0.675rem',
                            }}
                            disabled={isEmpty(stations) || imageUploading}
                            onClick={() => setCapturePhoto(true)}
                          >
                            TAKE PHOTO
                          </Button>
                        )}
                        <Button
                          type='submit'
                          variant='contained'
                          color='primary'
                          disabled={isEmpty(stations) || imageUploading}
                          sx={{
                            textTransform: 'none',
                            p: '6px 10px',
                            fontSize: '0.675rem',
                          }}
                        >
                          SUBMIT
                        </Button>
                      </Box>
                      {/* {values?.photo_url && (
                        <img
                          src={values?.photo_url}
                          alt='Uploaded Preview'
                          style={{
                            width: '50px',
                            height: '50px',
                            marginTop: 8,
                            borderRadius: '6px',
                          }}
                        />
                      )} */}
                    </Box>
                  </form>
                )}
              </Formik>
            )}

            {/* Station Updates List */}
            {!isEmpty(
              includes(roles, 'SUPERVISOR')
                ? filter(stationUpdateList, {
                    station_name: selectedDepartment,
                  })
                : stationUpdateList
            ) && (
              <Box sx={{ mt: 3 }}>
                <TableContainer
                  sx={{ overflowX: 'auto', backgroundColor: '#f9f9f9' }}
                >
                  <Table>
                    <TableHead>
                      <TableRow>
                        {/* {includes(roles, 'STATION SUPERVISOR MANAGER') && ( */}
                        <TableCell
                          sx={{
                            padding: '10px',
                            backgroundColor: '#2F3542',
                            fontWeight: 700,
                            color: '#fff',
                            textAlign: 'center',
                            borderBottom: '2px solid #e0e0e0',
                            borderRight: '1px solid #FFF',
                            borderTopLeftRadius: '1rem',
                            fontSize: '0.675rem',
                          }}
                        >
                          {includes(roles, 'SUPERVISOR') ? 'STOCK' : 'STATION'}
                        </TableCell>
                        {/* )} */}
                        <TableCell
                          sx={{
                            padding: '10px',
                            backgroundColor: '#2F3542',
                            fontWeight: 700,
                            color: '#fff',
                            textAlign: 'center',
                            borderBottom: '2px solid #e0e0e0',
                            borderRight: '1px solid #FFF',
                            fontSize: '0.675rem',
                          }}
                        >
                          TIME
                        </TableCell>
                        <TableCell
                          sx={{
                            padding: '10px',
                            backgroundColor: '#2F3542',
                            fontWeight: 700,
                            color: '#fff',
                            textAlign: 'center',
                            borderBottom: '2px solid #e0e0e0',
                            borderRight: '1px solid #FFF',
                            borderTopRightRadius: '1rem',
                            fontSize: '0.675rem',
                          }}
                        >
                          PHOTO
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(includes(roles, 'SUPERVISOR')
                        ? filter(stationUpdateList, {
                            station_name: selectedDepartment,
                          })
                        : stationUpdateList
                      ).map((station, index) => {
                        let photoList = [];
                        if (station?.photo_url) {
                          const sanitizedPhotoUrl = station.photo_url.replace(
                            /,\s*$/,
                            ''
                          );
                          try {
                            photoList = JSON.parse(sanitizedPhotoUrl);
                          } catch (error) {
                            console.error(
                              'Failed to parse photo_url:',
                              station
                            );
                          }
                        }
                        return (
                          <TableRow
                            key={station.id}
                            sx={{
                              backgroundColor:
                                index % 2 === 0 ? '#fff' : '#eaf3ff',
                              // '&:hover': { backgroundColor: '#e0f7fa' },
                            }}
                          >
                            {/* {includes(roles, 'STATION SUPERVISOR MANAGER') && ( */}
                            <TableCell
                              sx={{
                                padding: '10px',
                                textAlign: 'center',
                                fontWeight: 700,
                                color: '#000',
                                fontSize: '0.675rem',
                              }}
                            >
                              <div>
                                {!includes(roles, 'SUPERVISOR') && (
                                  <div
                                    style={{
                                      fontWeight: 'bold',
                                      color: '#000',
                                    }}
                                  >
                                    {station.station_name}
                                  </div>
                                )}
                                <div
                                  style={{
                                    color: '#777',
                                    fontSize: '12px',
                                    marginTop: '5px',
                                  }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      gap: 1,
                                      fontSize: '0.675rem',
                                    }}
                                  >
                                    <span style={{ marginLeft: '5px' }}>
                                      {includes(roles, 'SUPERVISOR')
                                        ? 'AVAILABLE:'
                                        : 'STOCK AVAILABLE:'}
                                    </span>
                                    {station.stock_available ? (
                                      <IoMdCheckboxOutline
                                        fill='green'
                                        size={20}
                                      />
                                    ) : (
                                      <RxCrossCircled
                                        fill='red'
                                        size={20}
                                        style={{ color: 'red' }}
                                      />
                                    )}
                                  </div>
                                </div>
                                <div
                                  style={{
                                    color: '#777',
                                    fontSize: '12px',
                                    marginTop: '5px',
                                  }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      gap: 1,
                                      fontSize: '0.675rem',
                                    }}
                                  >
                                    {/* <GiCheckMark
                                  style={{ color: '#06b806' }}
                                  size={14}
                                /> */}
                                    <span style={{ marginLeft: '5px' }}>
                                      {includes(roles, 'SUPERVISOR')
                                        ? 'REQUIRED:'
                                        : 'Stock REQUIRED:'}
                                    </span>
                                    {station.stock_required ? (
                                      <IoMdCheckboxOutline
                                        fill='green'
                                        size={20}
                                      />
                                    ) : (
                                      <RxCrossCircled
                                        fill='red'
                                        size={20}
                                        style={{ color: 'red' }}
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                            </TableCell>
                            {/* )} */}
                            <TableCell
                              sx={{
                                padding: '10px',
                                textAlign: 'center',
                                fontWeight: 700,
                                color: '#333',
                                fontSize: '0.675rem',
                              }}
                            >
                              {/* {station.submission_timestamp} */}

                              <div>
                                <div
                                  style={{ fontWeight: 'bold', color: '#000' }}
                                >
                                  {moment(station.submission_timestamp)?.format(
                                    'DD/MM/YYYY HH:mm'
                                  )}
                                </div>
                                <div
                                  style={{
                                    color: '#777',
                                    fontSize: '12px',
                                    marginTop: '5px',
                                    fontSize: '0.675rem',
                                  }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      gap: 1,
                                    }}
                                  >
                                    <span style={{ marginLeft: '5px' }}>
                                      LAT:
                                    </span>
                                    {station?.latitude
                                      ? Number(station?.latitude)?.toFixed(3)
                                      : ''}
                                  </div>
                                </div>
                                <div
                                  style={{
                                    color: '#777',
                                    fontSize: '12px',
                                    marginTop: '5px',
                                  }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      gap: 1,
                                      fontSize: '0.675rem',
                                    }}
                                  >
                                    {/* <GiCheckMark
                                  style={{ color: '#06b806' }}
                                  size={14}
                                /> */}
                                    <span style={{ marginLeft: '5px' }}>
                                      LNG:
                                    </span>
                                    {station?.longitude
                                      ? Number(station?.longitude)?.toFixed(3)
                                      : ''}
                                  </div>
                                </div>
                              </div>
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: '10px',
                                textAlign: 'center',
                                fontSize: '0.675rem',
                              }}
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 1,
                                  justifyContent: 'center',
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                  }}
                                >
                                  {!isEmpty(photoList) &&
                                    map(photoList, (data) => (
                                      <img
                                        width={40}
                                        height={40}
                                        style={{
                                          borderRadius: '4px',
                                          cursor: 'pointer',
                                          border: '1px solid #e0e0e0',
                                        }}
                                        src={`${process.env.REACT_APP_IMAGE_URL}/images/${data}`}
                                        onClick={() => {
                                          handleOpen();
                                          setImageUrl(data);
                                        }}
                                        key={data}
                                      />
                                    ))}
                                </div>
                                <input
                                  accept='image/*'
                                  style={{ display: 'none' }}
                                  id='upload-file-table'
                                  type='file'
                                  onChange={(e) =>
                                    handleFileChange(
                                      e?.target?.files?.[0],
                                      station?.id,
                                      photoList
                                    )
                                  }
                                />
                                <Button
                                  component='label'
                                  htmlFor='upload-file-table'
                                  variant='contained'
                                  sx={{
                                    fontSize: '0.675rem',
                                    px: 0.5,
                                    py: 0.2,
                                  }}
                                >
                                  <MdOutlineFileUpload size={18} /> UPLOAD
                                </Button>
                              </Box>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}

            <ImageModal
              open={modalOpen}
              handleClose={handleClose}
              imageUrl={imageUrl}
            />
          </Paper>
        </Container>
      </div>
      <Footer />
    </div>
  );
};

export default SupervisorForm;

export const ImageModal = ({ open, handleClose, imageUrl }) => {
  // <Modal
  //   open={open}
  //   onClose={handleClose}
  //   aria-labelledby='image-modal-title'
  //   aria-describedby='image-modal-description'
  // >
  //   <Box
  //     sx={{
  //       display: 'flex',
  //       justifyContent: 'center',
  //       alignItems: 'center',
  //       height: '100%',
  //       backgroundColor: 'rgba(0, 0, 0, 0.6)', // Darker background for focus
  //       position: 'relative', // Positioning for the close button
  //       padding: 2,
  //     }}
  //   >
  //     <Box
  //       sx={{
  //         position: 'relative',
  //         display: 'flex',
  //         justifyContent: 'center',
  //         alignItems: 'center',
  //         backgroundColor: 'white',
  //         borderRadius: 2,
  //         boxShadow: 3, // Add some shadow for a clean effect
  //         overflow: 'hidden',
  //         maxWidth: '90%', // Limit width for larger screens
  //         maxHeight: '80vh', // Limit height for large images
  //         padding: 2, // Padding inside the modal
  //       }}
  //     >
  //       <img
  //         src={`${process.env.REACT_APP_IMAGE_URL}/images/${imageUrl}`}
  //         alt='Station'
  //         style={{
  //           maxWidth: '100%',
  //           maxHeight: '100%',
  //           objectFit: 'contain', // Ensure the image is contained within the modal
  //         }}
  //       />
  //       {/* Close Button */}
  //       <IconButton
  //         onClick={handleClose}
  //         sx={{
  //           position: 'absolute',
  //           top: 16,
  //           right: 16,
  //           color: 'red', // Red close button
  //           zIndex: 10, // Ensure the button stays above the image
  //           borderRadius: '50%',
  //           backgroundColor: 'rgba(255, 255, 255, 0.7)', // Slight background to make button more visible
  //           padding: 1,
  //           '&:hover': {
  //             backgroundColor: 'rgba(255, 0, 0, 0.2)', // Hover effect for button
  //           },
  //         }}
  //       >
  //         <IoClose size={24} />
  //       </IconButton>
  //     </Box>
  //   </Box>
  // </Modal>

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          width: '100vw',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          position: 'fixed',
          top: 0,
          left: 0,
          padding: 2,
          boxSizing: 'border-box',
        }}
        onClick={handleClose} // Close when clicking outside
      >
        <Box
          sx={{
            position: 'relative',
            width: 500, // Medium width
            maxWidth: '90%', // Responsive for smaller screens
            borderRadius: 2,
            overflow: 'hidden',
            boxShadow: 3,
            backgroundColor: '#fff',
          }}
          onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
        >
          {/* Close Button */}
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              color: '#fff',
              backgroundColor: 'rgba(0,0,0,0.6)',
              '&:hover': { backgroundColor: 'rgba(0,0,0,0.8)' },
              zIndex: 10,
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Image */}
          <img
            src={`${process.env.REACT_APP_IMAGE_URL}/images/${imageUrl}`}
            alt='Station'
            style={{
              display: 'block',
              width: '100%', // Fill container width
              height: 'auto', // Maintain aspect ratio
              objectFit: 'contain',
              cursor: 'pointer', // shows it's clickable
            }}
            // onClick={() =>
            //   `${process.env.REACT_APP_IMAGE_URL}/images/${imageUrl}`
            // }
          />
        </Box>
      </Box>
    </Modal>
  );
};
